import { empty } from './strings.js';
import { getRawType, date as dateType } from './types.js';
const EEE = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const now = new Date();
export const padZero = (num) => String(num > 9 ? num : `0${num}`);
export function dateFormatFn(date, format) {
    const formats = {
        dd: padZero(date.getDate()),
        mm: padZero(date.getMonth() + 1),
        yyyy: String(date.getFullYear()),
        yy: date.getFullYear().toString().substr(2),
    };
    return dateFormatter(format, formats);
}
export function dateTimeFormatFn(date, format) {
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();
    const formats = {
        EEE: EEE[date.getDay()],
        YYYY: String(date.getFullYear()),
        YY: String(date.getFullYear().toString().substring(2)),
        MM: padZero(date.getMonth() + 1),
        DD: padZero(date.getDate()),
        hh: String((hours + 24) % 12 || 12),
        HH: padZero(hours),
        mm: padZero(minutes),
        ss: padZero(seconds),
        pp: hours > 11 ? 'pm' : 'am',
        PP: hours > 11 ? 'PM' : 'AM',
    };
    return dateFormatter(format, formats);
}
function dateFormatter(format, formats) {
    const arr = [];
    return format.split('').reduce((result, value, index) => {
        if (arr.length) {
            let context = arr[arr.length - 1];
            if (context.substr(-1) === value) {
                context = arr[arr.length - 1] += value;
                return format.length === index + 1 ? result + (formats[context] || context) : result;
            }
            else {
                arr.push(value);
                return result + (formats[context] || context);
            }
        }
        arr.push(value);
        return result;
    }, '');
}
export function parseDate(dateString, formats, date = new Date(), future = true) {
    const lastIndex = dateString.length - 1;
    const methods = {
        d: (value) => date.setDate(value),
        m: (value) => date.setMonth(value - 1),
        y: (value) => date.setFullYear(calcFullYear(value, future)),
    };
    return formats.split(empty).reduce((store, current, index) => {
        if ((store.prev && current !== store.prev) || index === lastIndex) {
            const caller = methods[store.prev || current];
            caller && caller(parseInt(dateString.substring(store.startIndex, index + 1)));
            store.startIndex = index;
        }
        store.prev = current;
        return store;
    }, { date, startIndex: 0, prev: null }).date;
}
/**
 * Calculates a full 4-digit year from any digits
 */
export function calcFullYear(year, future = true, divisor = 100) {
    const yearNumber = parseInt(year);
    if (yearNumber < divisor) {
        const currentYear = now.getFullYear();
        const baseYear = Math.floor(currentYear / divisor) * divisor;
        const calcYear = baseYear + (yearNumber % divisor);
        if (future && calcYear < currentYear) {
            return calcYear + divisor;
        }
        if (calcYear < currentYear) {
            return calcYear - divisor;
        }
        return calcYear;
    }
    return yearNumber;
}
export function yearsDiff(date, refDate) {
    const diff = new Date(refDate.getTime() - date.getTime());
    return diff.getFullYear() - 1970;
}
export function isValidDate(date) {
    return getRawType(date) === dateType && !isNaN(date);
}
//# sourceMappingURL=date.js.map